module.exports = __webpack_public_path__ + "img/icon-arrow-success.57c78d69.svg";